"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

import { cn } from "../../lib/utils";
import { useTranslation } from "../translate";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

export function ModeToggle() {
  const { setTheme, theme } = useTheme();
  const { dictionary } = useTranslation();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  if (!mounted) {
    // Return a placeholder button that matches the default state to avoid hydration mismatch
    return (
      <Button
        variant="outline"
        size="icon"
        className="rounded-full"
        aria-label={dictionary["Byt tema"]}
        disabled
      >
        <Skeleton className="h-4 w-4" />
        <span className="sr-only">{dictionary["Byt tema"]}</span>
      </Button>
    );
  }

  return (
    <Button
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      variant="outline"
      size="icon"
      className="rounded-full"
      aria-label={dictionary["Byt tema"]}
    >
      <Sun
        className={cn(
          "h-[1.2rem] w-[1.2rem] rotate-0 transition-all dark:-rotate-90 text-foreground",
          { hidden: theme === "light" },
        )}
      />
      <Moon
        className={cn(
          "absolute h-[1.2rem] w-[1.2rem] rotate-90 transition-all dark:rotate-0 text-muted-foreground",
          { hidden: theme === "dark" },
        )}
      />
      <span className="sr-only">{dictionary["Byt tema"]}</span>
    </Button>
  );
}
